import { render } from "./Download.vue?vue&type=template&id=27a7ae69"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import "./Download.vue?vue&type=style&index=0&id=27a7ae69&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__